import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'

export default {
  getCalls(data) {
    return apiCallCenter().post(
      `/relatorios/filas/detalhado?page=${data.currentPage}&_method=GET&itensPerPage=20`,
      data
    )
  },
  
  exportExcel(params) {
    
    
    let query = new URLSearchParams(params.dateTimeRange).toString();

    if(params.filas.length == 0){
      query = `${query}&filas[]=${params.filas}`
    }else{
      params.filas.forEach(fila => {
        query = `${query}&filas[]=${fila}`
      })
    }
    
    if(params.status.length == 0){
      query = `${query}&status[]=${params.status}`
    }else{
      params.status.forEach(status => {
        query = `${query}&status[]=${status}`
      })
    }

    if(params.numeroOrigem.length == 0){
      query = `${query}&numeroOrigem[]=${params.numeroOrigem}`
    }else{
      params.numeroOrigem.forEach(numeroOrigem => {
        query = `${query}&numeroOrigem[]=${numeroOrigem}`
      })
    }

    if(params.centrosDeCusto.length == 0){
      query = `${query}&centrosDeCusto[]=${params.centrosDeCusto}`
    }else{
      params.centrosDeCusto.forEach(centrosDeCusto => {
        query = `${query}&centrosDeCusto[]=${centrosDeCusto}`
      })
    }


    if(params.maiorQue != 0){
      query = `${query}&maiorQue=${params.maiorQue}`
    }else{
      query = `${query}&maiorQue=0`
    }
    if(params.menorQue != 0){
      query = `${query}&menorQue=${params.menorQue}`
    }else{
      query = `${query}&menorQue=0`
    }

    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/filas/detalhado/export?${query}`
  },
}
